
import React from "react";
import { Link } from "react-router-dom";

export const Footer: React.FC = () => {
  return (
    <footer className="bg-gray-900 text-gray-300 py-16">
      <div className="container mx-auto px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          <div>
            <a href="#" className="inline-block mb-6">
              <span className="text-2xl font-medium text-white">HeyVail</span>
            </a>
            <p className="text-gray-400 mb-6">
              AI-powered lead generation and qualification that helps businesses grow without the busy-ness.
            </p>
          </div>
          
          <div>
            <h3 className="text-lg font-medium text-white mb-6">Product</h3>
            <ul className="space-y-4">
              <li><a href="#features" className="text-gray-400 hover:text-white transition-colors">Features</a></li>
              <li><Link to="/case-studies/b2b-lending" className="text-gray-400 hover:text-white transition-colors">Case Studies</Link></li>
            </ul>
          </div>
          
          <div>
            <h3 className="text-lg font-medium text-white mb-6">Company</h3>
            <ul className="space-y-4">
              <li><a href="#contact" className="text-gray-400 hover:text-white transition-colors">Contact</a></li>
            </ul>
          </div>
          
          <div>
            <h3 className="text-lg font-medium text-white mb-6">Legal</h3>
            <ul className="space-y-4">
              <li><Link to="/privacy-policy" className="text-gray-400 hover:text-white transition-colors">Privacy Policy</Link></li>
              <li><Link to="/terms-of-service" className="text-gray-400 hover:text-white transition-colors">Terms of Service</Link></li>
              <li><Link to="/cookie-policy" className="text-gray-400 hover:text-white transition-colors">Cookie Policy</Link></li>
              <li><Link to="/gdpr" className="text-gray-400 hover:text-white transition-colors">GDPR</Link></li>
            </ul>
          </div>
        </div>
        
        <div className="mt-12 pt-8 border-t border-gray-800">
          <p className="text-gray-500 text-center">
            &copy; {new Date().getFullYear()} HeyVail. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};
